import { InputTextArea as InputTextAtom } from '@/components/atoms'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'

export const InputTextArea = ({
  name,
  type,
  value,
  onChange,
  placeholder,
  label,
  icon,
  required,
  maxLength,
  className,
  styleButton,
  readOnly,
  disabled,
  rules,
  cols,
  rows,
  style,
  onBlurCaptureFun,
  onBlur,
  onKeyDown,
  classFS,
  onClick
}) => {
  return (
    <div className={`${styles.input} ${className}`}>
      <label htmlFor={name}>{label}</label>
      {icon
        ? (
          <span className='p-input-icon-left'>
            <i className={icon} />
            <InputTextAtom
              name={name}
              type={type}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              required={required}
              maxLength={maxLength}
              invalidClassName={styles.invalid}
              className={`${readOnly && styles.readonly} ${disabled && styles.disabled} ${classFS && styles.fS60}`}
              styleButton={{ ...styleButton, ...style }}
              disabled={disabled}
              readOnly={readOnly}
              rows={rows}
              cols={cols}
              rules={rules}
              invalidMessageClassName={styles.invalid_message}
              style={style}
              onBlurCaptureFun={onBlurCaptureFun}
              onBlur={onBlur}
              onKeyDown={onKeyDown}
              onClick={onClick}
            />
          </span>)
        : (
          <InputTextAtom
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            maxLength={maxLength}
            invalidClassName={styles.invalid}
            className={`${readOnly && styles.readonly} ${disabled && styles.disabled} ${classFS && styles.fS60}`}
            styleButton={{ ...styleButton, ...style }}
            disabled={disabled}
            readOnly={readOnly}
            rows={rows}
            cols={cols}
            rules={rules}
            invalidMessageClassName={styles.invalid_message}
            style={style}
            onBlurCaptureFun={onBlurCaptureFun}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
          />)}
    </div>
  )
}

InputTextArea.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string
}
